import './App.css'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { LocalizationProvider } from './components/providers/LocalizationProvider.jsx'
import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/sonner"

function App() {
  return (
    <AuthProvider>
      <LocalizationProvider>
        <Pages />
        <Toaster />
      </LocalizationProvider>
    </AuthProvider>
  )
}

export default App 